// Internal modules
import { $logger } from '@/lib/logger';

const logCountryChange = data => {
  const { fromCountry, toCountry, transitionName, ...rest } = data;
  $logger.fpti(transitionName, {
    billing_country: fromCountry,
    billing_country_changed: toCountry,
    state_name: 'change_country',
    transition_name: transitionName,
    ...rest,
  });
};

export const logCountryChangeAttemptToFPTI = payload => {
  logCountryChange({ transitionName: 'prep_change_cntry', ...payload });
};

export const logCountryChangeSuccessToFPTI = payload => {
  logCountryChange({
    transitionName: 'process_change_cntry',
    ...payload,
  });
};

export const logCountryChangeErrorToFPTI = payload => {
  logCountryChange({
    transitionName: 'process_change_cntry_error',
    ...payload,
  });
};
